import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import style from "./DonationDetails.module.scss";
import { Distribution, Donation } from "../../../../../models";
import { Organization } from "../../../../shared/components/Widget/types/Organization";
import { CauseArea } from "../../../../shared/components/Widget/types/CauseArea";
import DonationImpact, { DonationImpactItemsConfiguration } from "../../../donations/DonationImpact/DonationImpact";
import { mapNameToOrgAbbriv } from "../../../../../util/mappings";
import AnimateHeight from "react-animate-height";
import { LinkType, Links } from "../../../../main/blocks/Links/Links";
import { PortableText } from "@portabletext/react";
import { NavLink } from "../../../../shared/components/Navbar/Navbar";
import { groupDonationImpactByCauseArea } from "./impactGroups";
type ImpactEstimateExplanationConfiguration = {
  impact_estimate_explanation_title?: string;
  impact_estimate_explanation_text?: any[];
  impact_estimate_explanation_links?: (LinkType | NavLink)[];
};
type CauseAreaImpactEstimateConfiguration = ImpactEstimateExplanationConfiguration & {
  cause_area_id: number;
};
export type DonationDetailsConfiguration = {
  impact_estimate_header?: string;
  cause_area_impact_estimates?: CauseAreaImpactEstimateConfiguration[];
  impact_items_configuration: DonationImpactItemsConfiguration;
};
export const DonationDetails: React.FC<{
  sum: string;
  donation: Donation;
  distribution: Distribution;
  timestamp: Date;
  configuration: DonationDetailsConfiguration;
  organizations: Organization[];
  causeAreas: CauseArea[];
}> = t0 => {
  const $ = _c(26);
  const {
    donation,
    distribution,
    timestamp,
    configuration,
    organizations,
    causeAreas
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [expandedCauseAreaIds, setExpandedCauseAreaIds] = useState(t1);
  if (!distribution && !donation.impact?.length) {
    let t2;
    if ($[1] !== donation.KID) {
      t2 = <span>Ingen distribusjon funnet for donasjon med KID {donation.KID}</span>;
      $[1] = donation.KID;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] !== causeAreas || $[4] !== configuration.cause_area_impact_estimates || $[5] !== configuration.impact_estimate_header || $[6] !== configuration.impact_items_configuration || $[7] !== distribution || $[8] !== donation || $[9] !== expandedCauseAreaIds || $[10] !== organizations || $[11] !== timestamp) {
    const distributionCauseAreas = distribution?.causeAreas ?? [];
    const impactGroups = groupDonationImpactByCauseArea(donation.impact ?? [], organizations, causeAreas);
    const hasPrecomputedImpact = Boolean(donation.impact?.length);
    const visibleCauseAreas = hasPrecomputedImpact ? impactGroups.map(_temp) : distributionCauseAreas;
    t5 = style.wrapper;
    t2 = style.impactEstimate;
    if ($[16] !== configuration.impact_estimate_header) {
      t3 = <strong>{configuration.impact_estimate_header}</strong>;
      $[16] = configuration.impact_estimate_header;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    t4 = visibleCauseAreas.map(causeArea => {
      const causeAreaId = causeArea.id;
      const causeAreaDistribution = distribution && !hasPrecomputedImpact ? {
        ...distribution,
        causeAreas: distributionCauseAreas.filter(distributionCauseArea => distributionCauseArea.id === causeAreaId)
      } : distribution;
      const impactGroup = impactGroups.find(group_0 => group_0.causeArea.id === causeAreaId);
      const causeAreaDonation = hasPrecomputedImpact ? {
        ...donation,
        impact: impactGroup?.impact
      } : donation;
      const impactEstimateConfiguration = configuration.cause_area_impact_estimates?.find(candidate => candidate.cause_area_id === causeAreaId);
      const showImpactEstimateExplanation = expandedCauseAreaIds.includes(causeAreaId);
      return <div key={causeAreaId}>{(impactGroup?.showTitle ?? visibleCauseAreas.length > 1) && <h5>{causeArea.name}</h5>}{impactEstimateConfiguration?.impact_estimate_explanation_title && <><span className={showImpactEstimateExplanation ? [style.caption, style.captionopen].join(" ") : style.caption} onClick={() => setExpandedCauseAreaIds(current => current.includes(causeAreaId) ? current.filter(id => id !== causeAreaId) : [...current, causeAreaId])}>{impactEstimateConfiguration.impact_estimate_explanation_title}  </span><AnimateHeight duration={500} height={showImpactEstimateExplanation ? "auto" : 0}><div className={style.impactExplanationContainer}><PortableText value={impactEstimateConfiguration.impact_estimate_explanation_text} /><Links links={impactEstimateConfiguration.impact_estimate_explanation_links ?? []} /></div></AnimateHeight></>}<DonationImpact donation={causeAreaDonation} distribution={causeAreaDistribution as Distribution} timestamp={timestamp} configuration={configuration.impact_items_configuration} organizations={organizations} /></div>;
    });
    $[3] = causeAreas;
    $[4] = configuration.cause_area_impact_estimates;
    $[5] = configuration.impact_estimate_header;
    $[6] = configuration.impact_items_configuration;
    $[7] = distribution;
    $[8] = donation;
    $[9] = expandedCauseAreaIds;
    $[10] = organizations;
    $[11] = timestamp;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={style.actions} />;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t6) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
function _temp(group) {
  return group.causeArea;
}